import React from "react";
import { useInView } from "react-intersection-observer";
import { keyframes } from "@emotion/react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Define the animation keyframes
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const animatedStyles = (inView) => ({
  animation: inView ? `${fadeIn} 1s ease-in-out` : "none",
  opacity: inView ? 1 : 0,
  transition: "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
});

export default function Experience() {
  const { ref: experienceHeaderRef, inView: experienceHeaderInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  const { ref: freelanceSaudiRef, inView: freelanceSaudiInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  const { ref: freelanceSyriaRef, inView: freelanceSyriaInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  const { ref: leagueplsRef, inView: leagueplsInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  const { ref: gallardoRef, inView: gallardoInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  const { ref: yesRef, inView: yesInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  const { ref: swanRef, inView: swanInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  return (
    <>
      <style>{`
        .animated-bullet-svg {
          height: 1.2em;
          width: 1.2em;
          vertical-align: -0.2em;
          margin-right: 0.3em;
          fill: #007bff;
          transition: fill 0.3s ease-in-out, transform 0.3s ease-in-out;
        }
        .animated-bullet-item:hover .animated-bullet-svg {
          fill: #1976d2;
          transform: rotate(10deg) scale(1.1);
        }
        .section-header {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 2rem;
        }
        .section-header .svg-icon {
          height: 40px;
          width: 40px;
          // fill: #007bff;
          fill: #FFF;
          transition: fill 0.3s ease-in-out;
        }
        .section-header:hover .svg-icon {
          fill: #1976d2;
        }
      `}</style>

      <div className="bg-section experience-section experience-card">
        <Container maxWidth="lg">
          <div className="section-header" ref={experienceHeaderRef} style={animatedStyles(experienceHeaderInView)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="svg-icon"
              //  ref={svgIconRef}
              // style={animatedStyles(svgIconInView)} // Apply the animation here
            
            >
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
            </svg>
            <h4 className="section-title">Experience</h4>
          </div>
          <Grid container spacing={4} marginBottom={3}>
            {/* Freelance With Team In Soudi */}
            <Grid
              item
              xs={12}
              md={6}
              marginBottom={1}
              ref={freelanceSaudiRef}
              sx={animatedStyles(freelanceSaudiInView)}
            >
              <div className="card">
                <div className="card-body">
                  <h4 className="mb-2 card-title">Freelance With Team In Soudi</h4>
                  <h5 className="mb-2 card-subtitle">Web Developer</h5>
                  <div className="card-subtitle">Feb 2025 – present</div>
                  <div className="description my-3 text-left card-text">
                    Working remotely with a team programming in Saudi Arabia.
                    <ul>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        WordPress
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Grid>
            {/* Freelance With Team In Syria */}
            <Grid
              item
              xs={12}
              md={6}
              marginBottom={1}
              ref={freelanceSyriaRef}
              sx={animatedStyles(freelanceSyriaInView)}
            >
              <div className="card">
                <div className="card-body">
                  <h4 className="mb-2 card-title">Freelance With Team In Syria</h4>
                  <h5 className="mb-2 card-subtitle">React Developer</h5>
                  <div className="card-subtitle">Des 2023 – April 2024</div>
                  <div className="description my-3 text-left card-text">
                    Working remotely with a leading company in Syria.
                    <ul>
                    

                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Bootstrap
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        React.js
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Rest API
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Grid>
            {/* Leaguepls */}
            <Grid
              item
              // size={6}
              xs={12}
              md={6}
              marginBottom={1}
              ref={leagueplsRef}
              sx={animatedStyles(leagueplsInView)}
            >
              <div className="card">
                <div className="card-body">
                  <h4 className="mb-2 card-title">Leaguepls</h4>
                  <h5 className="mb-2 card-subtitle">Backend Developer</h5>
                  <div className="card-subtitle">June 2024 – Dec 2025</div>
                  <div className="description my-3 text-left card-text">
                    Working remotely with a leading company in Dubai - United Arab Emirates.
                    <ul>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Laravel
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        cPanel
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Rest API
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Postman
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        MySql
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Grid>
            {/* Gallardo Media */}
            <Grid
              item
              xs={12}
              md={6}
              ref={gallardoRef}
              sx={animatedStyles(gallardoInView)}
            >
              <div className="card">
                <div className="card-body">
                  <h4 className="mb-2 card-title">Gallardo Media</h4>
                  <h5 className="mb-2 card-subtitle">Full stack Developer</h5>
                  <div className="card-subtitle">Des 2023 – April 2024</div>
                  <div className="description my-3 text-left card-text">
                    Working with a Kuwaiti startup and a high-level team.
                    <ul>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Html
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Css
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        JavaScript
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Bootstrap
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Grid>
            {/* Yes */}
            <Grid
              item
              xs={12}
              md={6}
              ref={yesRef}
              sx={animatedStyles(yesInView)}
            >
              <div className="card">
                <div className="card-body">
                  <h4 className="mb-2 card-title">Yes</h4>
                  <h5 className="mb-2 card-subtitle">Front End Developer</h5>
                  <div className="card-subtitle">May 2023 - Oct 2023</div>
                  <div className="description my-3 text-left card-text">
                    Working in company in Syria.
                    <ul>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Html
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Css
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        JavaScript
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Bootstrap
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Reactjs
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Rest API
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Material UI
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Grid>
            {/* Swan */}
            <Grid
              item
              xs={12}
              md={6}
              ref={swanRef}
              sx={animatedStyles(swanInView)}
            >
              <div className="card">
                <div className="card-body">
                  <h4 className="mb-2 card-title">Swan</h4>
                  <h5 className="mb-2 card-subtitle">Front End Developer</h5>
                  <div className="card-subtitle">Sep 2022 – Mar 2023</div>
                  <div className="description my-3 text-left card-text">
                    Working in company in Syria.
                    <ul>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Html
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Css
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Js
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Bootstrap
                      </li>
                      <li className="animated-bullet-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="animated-bullet-svg"
                        >
                          <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                        </svg>
                        Laravel
                      </li>

                    </ul>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}













                      // <li className="animated-bullet-item">
                      //   <svg
                      //     xmlns="http://www.w3.org/2000/svg"
                      //     width="24"
                      //     height="24"
                      //     viewBox="0 0 24 24"
                      //     fill="none"
                      //     stroke="currentColor"
                      //     strokeWidth="2"
                      //     strokeLinecap="round"
                      //     strokeLinejoin="round"
                      //     className="animated-bullet-svg"
                      //   >
                      //     <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                      //   </svg>
                      //   Html
                      // </li>
                      // <li className="animated-bullet-item">
                      //   <svg
                      //     xmlns="http://www.w3.org/2000/svg"
                      //     width="24"
                      //     height="24"
                      //     viewBox="0 0 24 24"
                      //     fill="none"
                      //     stroke="currentColor"
                      //     strokeWidth="2"
                      //     strokeLinecap="round"
                      //     strokeLinejoin="round"
                      //     className="animated-bullet-svg"
                      //   >
                      //     <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                      //   </svg>
                      //   Css
                      // </li>
                      // <li className="animated-bullet-item">
                      //   <svg
                      //     xmlns="http://www.w3.org/2000/svg"
                      //     width="24"
                      //     height="24"
                      //     viewBox="0 0 24 24"
                      //     fill="none"
                      //     stroke="currentColor"
                      //     strokeWidth="2"
                      //     strokeLinecap="round"
                      //     strokeLinejoin="round"
                      //     className="animated-bullet-svg"
                      //   >
                      //     <path d="M17.41 7.21l-7.29 7.29a1 1 0 0 1-1.42 0L5.29 12.5a1 1 0 0 1 0-1.42l1.42-1.42a1 1 0 0 1 1.42 0l2.12 2.12 6.86-6.86a1 1 0 0 1 1.42 0l1.42 1.42a1 1 0 0 1 0 1.42z" />
                      //   </svg>
                      //   Js
                      // </li>